import React from 'react';
import { MenuItem, Select } from '@material-ui/core';
import { countryNameAndCodes } from '../constants';

interface CountryCodesMenuItemsProps {
  countryCode: string;
  handleCountryChange: (
    event: React.ChangeEvent<{
      value: unknown;
    }>
  ) => void;
}

export const CountryCodesMenuItems = (props: CountryCodesMenuItemsProps) => {
  const { countryCode, handleCountryChange } = props;

  return (
    <Select
      labelId="demo-simple-select-label"
      id="demo-simple-select"
      value={countryCode}
      onChange={handleCountryChange}
      style={{ maxWidth: '100%', whiteSpace: 'normal', margin: '5px 0 ' }}
    >
      {countryNameAndCodes.map((country) => (
        <MenuItem value={country.code} key={country.code} style={{ whiteSpace: 'normal' }}>
          {country.name} ({country.dial_code})
        </MenuItem>
      ))}
    </Select>
  );
};
